/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const INTERVAL = feature.getSettingValue('INTERVAL');
    const intervalStr = INTERVAL.toString().replace('.', '_');
    const NAME = `timer_${intervalStr}s_${feature.getID()}`;
    const tickLinks = project.getNodeLinks(feature, 'timer_tick');

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `let ${NAME}_timer;`,
    });

    blocks.push({
        location: 'RESET_VARIABLES',
        blockType: BlockType.CODE,
        template: `
clearInterval(${NAME}_timer);
${NAME}_timer = null;
`,
    });

    if (tickLinks.length > 0) {
        const link = tickLinks[0];
        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `\t${NAME}_timer = setInterval(async () => {
        if (simulator.paused) {
            return;
        }
        /****${link.getSourceId()}****/
        }, ${INTERVAL} * 1000)`,
        });
    }

    return blocks;
};
